import gql from 'graphql-tag';

const QuickStartShowcaseResultFields = gql`
	fragment QuickStartShowcaseResultFields on QuickStartShowcaseResult {
		quickStart {
			id
			projectId
			name
			description
			author
			featuredPhoto {
				id
				publicId
				isFeatured
				url
				x
				y
				width
				height
				rotation
			}
		}
		items {
			id
			productVariantId
			image {
				id
				description
				imageType
			}
			url
			manufacturer
			title
			unitPrice
			totalPrice
			quantity
			finish
			wasPrice
		}
	}
`;

export const PROJECT_QUICKSTART_DETAILS = gql`
	${QuickStartShowcaseResultFields}
	query ProjectQuickstartDetails($projectId: Int!) {
		projectShowcase(projectId: $projectId) {
			... on QuickStartShowcaseResult {
				...QuickStartShowcaseResultFields
			}
			... on NotFoundError {
				message
			}
		}
	}
`;

export const GET_FAVORITED_QUICKSTARTS = gql`
	query GetFavoritedQuickStarts($input: ProjectQuickStartsSearchCriteriaInput!) {
		discoverableQuickStarts(criteria: $input) {
			quickStarts {
				projectId
			}
		}
	}
`;

export const LIKE_QUICKSTART = gql`
	mutation LikeQuickStart($projectId: Int!) {
		likeQuickStart(projectId: $projectId)
	}
`;

export const UNLIKE_QUICKSTART = gql`
	mutation UnlikeQuickStart($projectId: Int!) {
		unlikeQuickStart(projectId: $projectId)
	}
`;
